import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo, useState } from 'react';

export default function useUniqueDocumentsBlocks(blocks) {
    const queryClient = useQueryClient();
    const initialLoadedDocuments = useMemo(() => {
        return blocks.reduce((acc, { uniqueDocuments = false, query, count }, index) => {
            if (!uniqueDocuments) {
                return [...acc, false];
            }
            const newQuery = {
                ...query,
                count,
                ...(index > 0
                    ? {
                          exclude_id: acc
                              .slice(0, index)
                              .filter((it) => it !== null && it !== false)
                              .reduce((acc, it) => [...acc, ...(it || [])], []),
                      }
                    : {}),
            };
            const { data = null } = queryClient.getQueryState(['documents', newQuery]) || {};
            const { data: items = null } = data || {};
            return [...acc, items !== null ? items.map(({ id }) => id) : null];
        }, []);
    }, [queryClient]);
    const [loadedDocuments, setLoadedDocuments] = useState(initialLoadedDocuments);
    const onDocumentsLoaded = useCallback(
        (blockIndex, documents) => {
            const newLoadedDocuments = [...loadedDocuments];
            newLoadedDocuments[blockIndex] = documents.map(({ id }) => id);
            setLoadedDocuments(newLoadedDocuments);
        },
        [loadedDocuments],
    );

    const newBlocks = useMemo(
        () =>
            blocks.map(({ uniqueDocuments = false, query, ...block }, blockIndex) =>
                uniqueDocuments
                    ? {
                          ...block,
                          query:
                              blockIndex > 0
                                  ? {
                                        ...query,
                                        exclude_id: loadedDocuments
                                            .slice(0, blockIndex)
                                            .filter((it) => it !== null && it !== false)
                                            .reduce((acc, it) => [...acc, ...(it || [])], []),
                                    }
                                  : query,
                          disabled: loadedDocuments
                              .slice(0, blockIndex)
                              .reduce((acc, val) => acc || val === null, false),
                          onLoaded: (items) => onDocumentsLoaded(blockIndex, items),
                      }
                    : {
                          ...block,
                          query,
                      },
            ),
        [blocks, loadedDocuments, onDocumentsLoaded],
    );

    return newBlocks;
}
